import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";

const headers = [
  { label: "User Name", key: "user_name" },
  { label: "User State", key: "user_state" },
  { label: "Mobile Number", key: "vba_mobile" },
  { label: "User Email", key: "user_email" },
  { label: "Donation Count", key: "donation_count" },
  { label: "India Positive Count", key: "ip_post_count" },
  { label: "Referral Count", key: "referral_count" },
  { label: "V4l Count", key: "v4l_share_count" },
  { label: "Your Voice Count", key: "yu_share_count" },
  { label: "Must Read Count", key: "mr_share_count" },
];

export default class Viksitdashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      status: "Active",
      donation: "completed",
    };
    this.viksitbharatList = this.viksitbharatList.bind(this);
    this.stateList = this.stateList.bind(this);
  }
  componentDidMount() {
    this.viksitbharatList();
    this.stateList();
  }
  loadMoreData = () => {
    this.viksitbharatList(this.state.selectedstate, "loadmore", "");
  };

  stateList = () => {
    var form = new FormData();
    form.append("action", "getstatelist");
    form.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    form.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");

    var settings = {
      url: "https://api.narendramodi.in/mlapiv1",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "ADRUM_BT=R%3A0%7Cg%3A48c9d406-532c-4eef-98d3-f21dad96c84c6%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29062%7Cd%3A12%7Ce%3A566",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    let ref = this;
    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState({
            statelist: response.data,
          });
        }
      } catch (ex) {}
    });
  };

  viksitbharatList = (e) => {
    console.log("hello", e);
    // $("#loader").css({ display: "block" });
    var ref = this;
    var form = new FormData();
    form.append("action", "getviksitbharattask");
    form.append("index", "0");
    form.append("state", e ? e : "");
    form.append(
      "token",
      "c2V2YV9tb2R1bGU6NTA4OTVhNjItOWY4MC00MGIyLTk2MzgtZWVmZDhjYjczMGQx"
    );

    var settings = {
      url: "https://api.narendramodi.in/nmspeech",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "NSC_10.10.24.75_443=ffffffff0902060945525d5f4f58455e445a4a423660",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState(
            {
              items: response.datalist,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };

  render() {
    var bread = "Viksit Bharat Ambassador / Dashboard";
    var items = this.state.items;
    var stateList = this.state.statelist;
    return (
      <div>
        <PageTitle
          title="#Viksit Bharat Ambassador"
          bread={bread}
          Count={this.state.post_count}
        />
        <div className="row row_date_div">
          <div
            className="row"
            style={{
              margin: "17px 0px 0px 76px",
            }}
          >
            <select
              id="state"
              name="state"
              className="form-control rigt_mar"
              onChange={(e) => this.viksitbharatList(e.target.value)}
              value={this.state.selectedstate}
            >
              <option value="">Select Your State</option>
              <option value="null">N/A</option>
              {Array.isArray(stateList) &&
                stateList.map((val, i) => {
                  return (
                    <option value={val.statename} key={i}>
                      {val.statename}
                    </option>
                  );
                })}
            </select>
          </div>

          <button
            style={{
              // padding: "0px 10px",
              "border-radius": "20px",
              "margin-left": "10px",
            }}
            className="btn-success"
            onClick={() => {
              window.location.reload();
            }}
          >
            Clear filters
          </button>
        </div>
        {/* <div
          className="form-inline form_right"
          style={{ top: "0px", right: "34px" }}
        >
          <div className="row row_date_div">
            <CSVLink
              style={{
                margin: "0px 0px 90px 0px",
                right: "0px",
                position: "absolute",
              }}
              data={items}
              headers={headers}
              filename="viksitbharat.csv"
            >
              <img
                style={{ width: "30px" }}
                alt="image"
                src="/img/filetype-csv.svg"
              />
            </CSVLink>
          </div>
        </div> */}
        <br />
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      <th>Name</th>
                      <th>State</th>
                      <th>Mobile Number</th>
                      <th>Email</th>
                      <th>Donation Count</th>
                      <th>Ip Count</th>
                      <th>Referral Count</th>
                      <th>V4l Count</th>
                      <th>Your Voice Count</th>
                      <th>Must Read Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items) &&
                      items.map((value, index) => {
                        return (
                          <tr>
                            <td>{value.user_name ? value.user_name : ""}</td>
                            <td>{value.user_state ? value.user_state : ""}</td>
                            <td>{value.vba_mobile ? value.vba_mobile : ""}</td>
                            <td>{value.user_email ? value.user_email : ""}</td>
                            <td>
                              {value.donation_count >= 50
                                ? "completed"
                                : value.donation_count}
                            </td>
                            <td>
                              {value.ip_post_count >= 50
                                ? "completed"
                                : value.ip_post_count}
                            </td>
                            <td>
                              {value.referral_count >= 50
                                ? "completed"
                                : value.referral_count}
                            </td>
                            <td>
                              {value.v4l_share_count >= 100
                                ? "completed"
                                : value.v4l_share_count}
                            </td>
                            <td>
                              {value.yu_share_count >= 10
                                ? "completed"
                                : value.yu_share_count}
                            </td>
                            <td>
                              {value.mr_share_count >= 50
                                ? "completed"
                                : value.mr_share_count}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ViksitBharat/Viksitdashboard.jsx